import { useForm } from 'react-hook-form';

import {
  Button,
  Input,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Text,
} from '@chakra-ui/react';
import { useEffect, useRef, useState } from 'react';
import Container from '../components/Container';
import { getInfo, useIdp } from '../services';
import PasswordPolicy from '../components/PasswordPolicy';

const ChangePassword = () => {
  const search = new URLSearchParams(window.location.search);
  const [error, setError] = useState(search.has('error'));
  const [errorMsg, setErrorMsg] = useState('We couldn\'t change your password, please contact support or try again');
  const ref = useRef();
  const { passwordPolicy } = useIdp() || {};

  const {
    handleSubmit,
    register,
    formState: { errors, isSubmitting, isValid },
    control,
    setValue,
    getValues,
    trigger,
  } = useForm({ mode: 'onChange' });

  const onSubmit = async (data) => {
    setError(false);
    const asd = window.AmazonCognitoAdvancedSecurityData.getData(data.user, '', search.get('client_id'));
    ref.current.asd.value = asd;
    ref.current.submit();
    return true;
  };

  const onHandleSubmit = (ev) => {
    ev.stopPropagation();
    ev.preventDefault();
    handleSubmit(onSubmit)();
  };

  useEffect(() => {
    const [rta, abortController] = getInfo('changePassword');

    rta.then((data = []) => {
      const f = data.find((d) => d.targetRequestPath === '/changePassword');
      if (f) {
        if (f.status === 'error') {
          window.location.replace(`/error${window.location.search}`);
        } else if (f.map?.errorMessage || f.map?.bindingResultErrors) {
          setErrorMsg(f.map.errorMessage || f.map.bindingResultErrors);
          setError(true);
        }
      }
    });
    return () => {
      abortController.abort();
    };
  }, []);

  return (
    <Container py="8">
      {/* eslint-disable-next-line max-len */}
      <form ref={ref} onSubmit={onHandleSubmit} action={`${process.env.REACT_APP_BACKEND}/auth/changePassword${window.location.search}`} method="POST">
        <Text fontSize="sm" color="gray.600">
          Please enter your new password below.
        </Text>
        {error && (
          <>
            {errorMsg.split('\n').map((err) => (
              <Text my="2" fontSize="sm" color="red.500" m="0">
                {err}
              </Text>
            ))}
          </>
        )}

        <FormControl my="6" isInvalid={errors.password}>
          <FormLabel mb="0.5" fontSize="sm">Password</FormLabel>
          <Input
            size="sm"
            type="password"
            placeholder="New password"
            {...register('password', { required: true, onChange: () => { trigger('confirmPassword'); } })}
          />
          <FormErrorMessage>The new password is required</FormErrorMessage>
        </FormControl>

        <FormControl my="6" isInvalid={errors.confirmPassword}>
          <FormLabel mb="0.5" fontSize="sm">Enter New Password Again</FormLabel>
          <Input
            size="sm"
            type="password"
            placeholder="New password"
            {...register('confirmPassword', {
              required: true,
              validate: (value) => {
                const { password } = getValues();
                return value === password;
              },
            })}
          />
          <FormErrorMessage>The password doesn&apos;t match</FormErrorMessage>
        </FormControl>

        <PasswordPolicy control={control} register={register} setValue={setValue} policy={passwordPolicy} />

        <input type="hidden" className="form-control" name="asd" />
        <Button colorScheme="blue" type="submit" size="sm" isLoading={isSubmitting} px="10" isDisabled={!isValid}>
          Reset my password
        </Button>
      </form>
    </Container>
  );
};

export default ChangePassword;
